<template>
    <div class="">
        <ul class="nav nav-tabs bg-primary pt-2 px-1">
            <li class="nav-item">
                <a
                    class="font-weight-bold text-primary"
                    :class="
                        goalStatusFilter === 0
                            ? 'nav-link active'
                            : 'btn btn-sm btn-outline m-1 bg-white'
                    "
                    @click="setParentProp('goalStatusFilter', 0)"
                    >Current Goals</a
                >
            </li>
            <li class="nav-item ml-auto">
                <a
                    class="font-weight-bold text-primary"
                    :class="
                        goalStatusFilter === 2
                            ? 'nav-link active'
                            : 'btn btn-sm btn-outline m-1 bg-white'
                    "
                    @click="setParentProp('goalStatusFilter', 2)"
                    >Mastered Goals</a
                >
            </li>
            <li class="nav-item">
                <a
                    class="font-weight-bold text-primary"
                    :class="
                        goalStatusFilter === 3
                            ? 'nav-link active'
                            : 'btn btn-sm btn-outline m-1 bg-white'
                    "
                    @click="setParentProp('goalStatusFilter', 3)"
                    >My Archived Goals</a
                >
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "GoalsStatusFilter",
    props: ["goalStatusFilter"],
    methods: {},
};
</script>

<style scoped></style>
